import React from 'react';
import PropTypes from 'prop-types';

const NotifyItem = ({ notificationMsg, children, notificationDate, className }) => {
	return (
		<div className={className}>
			<div className='notify_body'>
				<p className='notify-content li-style'>{notificationMsg} </p>
				{children && <div className=''>{children}</div>}
			</div>
			<span className='notify-date li-style ms-4'>{notificationDate} </span>
		</div>
	);
};
NotifyItem.propTypes = {
	notificationMsg: PropTypes.string.isRequired,
	children: PropTypes.node,
	notificationDate: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired
};
export default NotifyItem;
